/**
 * TODO: Replace Offer Cookie logic with PocketDerm API
 */
const OFFER_CATEGORIES = {
  freeTrial: 1,
  v1CurologyTwentyFivePercentOff: 2,
  v1AgencyTwentyFivePercentOff: 3,
  v2AgencyTwentyFivePercentOff: 4,
  v2CurologyFreeOTCProducts: 5,
  v2CurologyTwentyFivePercentOff: 6,
  agencyHigherPriceFreeTrial: 7,
  v3CurologyFreeOTCBundles: 8,
  v3Point1CurologyFreeOTCBundles: 9,
  v4CurologyFreeOTCBundlesV1Ui: 10,
  v4CurologyFreeOTCBundlesV2Ui: 11,
  v5CurologyCheckoutExperienceV1: 12,
  v6CurologyAuthPageBottleImage: 13,
  v6CurologyAuthPageDermatologistImage: 14,
  freeOtcTrial: 15,
  v8CurologyProviderConsultation: 16,
  freeOtcAndFreeDeepCleanseTrial: 17,
  v8CurologyProviderConsultation30Dollars: 18,
  freeOtcTrialV9: 19,
  v10Personalized: 20,
  v10Effective: 21,
  v10TellUsMore: 22,
  v11NoOTCItemsSelected: 23,
  v11CMSetSelected: 24,
  v12TraditionalDermVisitContrastNoDermFee: 25,
  v12TraditionalDermVisitContrastWithDermFee: 26,
  curologyLimitedTimeFreeTrial: 29,
} as const;

export { OFFER_CATEGORIES };
